import { getEnvClassicAssetData } from './assets-env';

const { assetString: iceAssetString } = getEnvClassicAssetData('ice');
const { assetString: governIceAssetString } = getEnvClassicAssetData('governIce');
const { assetString: upvoteIceAssetString } = getEnvClassicAssetData('upvoteIce');
const { assetString: dIceAssetString } = getEnvClassicAssetData('dIce');
const { assetString: gdIceAssetString } = getEnvClassicAssetData('gdIce');

export const DEFAULT_ICE_ASSETS = [iceAssetString, governIceAssetString, upvoteIceAssetString];

export const DELEGATED_ICE_ASSETS = [dIceAssetString, gdIceAssetString];

export const ICE_TO_DELEGATE = [upvoteIceAssetString, governIceAssetString];

export const ICE_DELEGATION_MAP = new Map([
    [upvoteIceAssetString, dIceAssetString],
    [governIceAssetString, gdIceAssetString],
]);

export const ALL_ICE_ASSETS = [...DEFAULT_ICE_ASSETS, ...DELEGATED_ICE_ASSETS];

export const PYUSD_CODE = 'PYUSD';
export const PYUSD_ISSUER = 'GDQE7IXJ4HUHV6RQHIUPRJSEZE4DRS5WY577O2FY6YQ5LVWZ7JZTU2V5';

export const USDT0_CODE = 'USDT0';
export const USDT0_ISSUER = 'GATISXX6BZ6NC7IKQBY37CJD4SOZL3CYZJWXEDG6JVIY4WBS6KXJHN6Q';
